import { BusinessContextModel } from '../../core/model/BusinessContext.model';
import { ItsmHttpQueryConfig } from './ItsmHttpQuery.config';

export const ItsmBusinessContextConfig: BusinessContextModel = {
  translateNamespace: 'itsm',
  queries: ItsmHttpQueryConfig,
};
